<div class="sp-dialog__max-width sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding__x2 sp-buyer-edit-dialog__columns-container">
    <div class="sp-buyer-edit-dialog__column-quarter">
      <form
        [formGroup]="buyer_residency_form_group"
        class="sp-margin__top-x2">
        <h3 class="sp-color__accent">
          {{ 'BUYERS.RESIDENCY_LABEL' | translate }}
        </h3>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.COUNTRY_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="country"
            [errorStateMatcher]="error_matcher"
            required />
        </mat-form-field>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.CITY_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="city"
            [errorStateMatcher]="error_matcher"
            required />
        </mat-form-field>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.PROVINCE_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="province"
            [errorStateMatcher]="error_matcher"
            required />
        </mat-form-field>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.ADDRESS_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="address"
            [errorStateMatcher]="error_matcher"
            required />
        </mat-form-field>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.HOUSE_NUMBER_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="house_number"
            [errorStateMatcher]="error_matcher"
            required />
        </mat-form-field>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.ZIP_CODE_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="zip_code"
            [errorStateMatcher]="error_matcher"
            required />
        </mat-form-field>
      </form>

      <form
        [formGroup]="buyer_domicile_form_group"
        class="sp-margin__top-x2">
        <h3 class="sp-color__accent">
          {{ 'BUYERS.DOMICILE_LABEL' | translate }}
        </h3>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.COUNTRY_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="country"
            [errorStateMatcher]="error_matcher" />
        </mat-form-field>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.CITY_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="city"
            [errorStateMatcher]="error_matcher" />
        </mat-form-field>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.PROVINCE_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="province"
            [errorStateMatcher]="error_matcher" />
        </mat-form-field>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.ADDRESS_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="address"
            [errorStateMatcher]="error_matcher" />
        </mat-form-field>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.HOUSE_NUMBER_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="house_number"
            [errorStateMatcher]="error_matcher" />
        </mat-form-field>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.ZIP_CODE_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="zip_code"
            [errorStateMatcher]="error_matcher" />
        </mat-form-field>
      </form>
    </div>

    <div class="sp-buyer-edit-dialog__column-quarter">
      <form
        [formGroup]="buyer_personal_info_form_group"
        class="sp-margin__top-x2">
        <h3 class="sp-color__accent">
          {{ 'BUYERS.PERSONAL_INFO_LABEL' | translate }}
        </h3>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.FIRSTNAME_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="buyer_firstname"
            [errorStateMatcher]="error_matcher"
            required />
        </mat-form-field>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.CITIZENSHIP_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="citizenship"
            [errorStateMatcher]="error_matcher"
            required />
        </mat-form-field>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.SECONDARY_CITIZENSHIP_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="secondary_citizenship"
            [errorStateMatcher]="error_matcher" />
        </mat-form-field>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.LASTNAME_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="buyer_lastname"
            [errorStateMatcher]="error_matcher"
            required />
        </mat-form-field>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.TAX_CODE_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="tax_code"
            [errorStateMatcher]="error_matcher"
            required />
        </mat-form-field>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.BIRTHDAY_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            [matDatepicker]="to_picker"
            formControlName="birthday"
            [errorStateMatcher]="error_matcher"
            required />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="to_picker"></mat-datepicker-toggle>
          <mat-datepicker #to_picker></mat-datepicker>
        </mat-form-field>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.BIRTHREGION_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="birthregion"
            [errorStateMatcher]="error_matcher"
            required />
        </mat-form-field>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.BIRTHREGION_CODE_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="birthregion_code"
            [errorStateMatcher]="error_matcher"
            required />
        </mat-form-field>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.BIRTHPLACE_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="birthplace"
            [errorStateMatcher]="error_matcher"
            required />
        </mat-form-field>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.BIRTHCOUNTRY_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="birthcountry"
            [errorStateMatcher]="error_matcher"
            required />
        </mat-form-field>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.GENDER_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="gender"
            [errorStateMatcher]="error_matcher"
            required />
        </mat-form-field>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.CDG_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="cdg"
            [errorStateMatcher]="error_matcher" />
        </mat-form-field>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.EMAIL_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="email"
            [errorStateMatcher]="error_matcher"
            required />
        </mat-form-field>

        <!--  <mat-form-field
        class="sp-width__full sp-margin__bottom-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'BUYERS.COMMUNICATION_CHANNEL_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="communication_channel"
          [errorStateMatcher]="error_matcher"
          required />
      </mat-form-field> -->
        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.COMMUNICATION_CHANNEL_LABEL' | translate }}
          </mat-label>
          <mat-select formControlName="communication_channel">
            <mat-option
              *ngFor="let option of communication_channel_options"
              [value]="option">
              {{ option | titlecase }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </form>
    </div>

    <div class="sp-buyer-edit-dialog__column-quarter">
      <form
        [formGroup]="buyer_personal_id_form_group"
        class="sp-margin__top-x2">
        <h3 class="sp-color__accent">
          {{ 'BUYERS.PERSONAL_ID_LABEL' | translate }}
        </h3>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.DOC_ISSUER_TYPE_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="issuer_type"
            [errorStateMatcher]="error_matcher"
            required />
        </mat-form-field>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.DOC_ISSUER_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="issuer"
            [errorStateMatcher]="error_matcher"
            required />
        </mat-form-field>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.DOC_ISSUE_COUNTRY_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="issue_country"
            [errorStateMatcher]="error_matcher"
            required />
        </mat-form-field>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.DOC_NUMBER_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="doc_number"
            [errorStateMatcher]="error_matcher"
            required />
        </mat-form-field>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.DOC_ISSUE_PROVINCE_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="issue_province"
            [errorStateMatcher]="error_matcher"
            required />
        </mat-form-field>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.DOC_TYPE_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="doc_type"
            [errorStateMatcher]="error_matcher"
            required />
        </mat-form-field>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.DOC_EMISSION_DATE_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            [matDatepicker]="to_issue_date_picker"
            formControlName="emission_date"
            [errorStateMatcher]="error_matcher"
            required />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="to_issue_date_picker"></mat-datepicker-toggle>
          <mat-datepicker #to_issue_date_picker></mat-datepicker>
        </mat-form-field>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.DOC_EXPIRATION_DATE_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            [matDatepicker]="to_expiring_date_picker"
            formControlName="expiration_date"
            [errorStateMatcher]="error_matcher"
            required />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="to_expiring_date_picker"></mat-datepicker-toggle>
          <mat-datepicker #to_expiring_date_picker></mat-datepicker>
        </mat-form-field>
      </form>
    </div>

    <div class="sp-buyer-edit-dialog__column-quarter">
      <form
        [formGroup]="buyer_aml_form_group"
        class="sp-margin__top-x2">
        <h3 class="sp-color__accent">
          {{ 'BUYERS.AML_LABEL' | translate }}
        </h3>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.AML_ACTIVITY_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="activity"
            [errorStateMatcher]="error_matcher"
            required />
        </mat-form-field>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.AML_SECTOR_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="sector"
            [errorStateMatcher]="error_matcher"
            required />
        </mat-form-field>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.AML_OCCUPATION_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="occupation"
            [errorStateMatcher]="error_matcher"
            required />
        </mat-form-field>

        <!-- <mat-form-field
        class="sp-width__full sp-margin__bottom-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'BUYERS.AML_APICAL_SUBJECT_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="is_apical_subject"
          [errorStateMatcher]="error_matcher"
          required />
      </mat-form-field> -->

        <mat-label>
          {{ 'BUYERS.AML_APICAL_SUBJECT_LABEL' | translate }}
        </mat-label>
        <mat-radio-group
          formControlName="is_apical_subject"
          class="sp-margin__top sp-margin__bottom-x2 sp-column">
          <mat-radio-button value="no">
            <span class="sp-color__primary"> {{ 'GENERAL.NO_LABEL' | translate }} </span>
          </mat-radio-button>
          <mat-radio-button value="yes">
            <span class="sp-color__primary"> {{ 'GENERAL.YES_LABEL' | translate }} </span>
          </mat-radio-button>
        </mat-radio-group>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.AML_BUSINESS_PLACE_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="business_place"
            [errorStateMatcher]="error_matcher"
            required />
        </mat-form-field>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.AML_TAE_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="tae"
            [errorStateMatcher]="error_matcher"
            required />
        </mat-form-field>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.AML_ACTIVITY_CODE_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="activity_code"
            [errorStateMatcher]="error_matcher"
            required />
        </mat-form-field>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.AML_SECTOR_CODE_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="sector_code"
            [errorStateMatcher]="error_matcher"
            required />
        </mat-form-field>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'BUYERS.AML_OCCUPATION_CODE_LABEL' | translate }}
          </mat-label>
          <input
            matInput
            type="text"
            formControlName="occupation_code"
            [errorStateMatcher]="error_matcher"
            required />
        </mat-form-field>
      </form>
    </div>

    <div class="sp-buyer-edit-dialog__full-width">
      <form
        [formGroup]="note_form_group"
        class="sp-margin__top-x2">
        <h3 class="sp-color__accent">
          {{ 'GENERAL.NOTE_LABEL' | translate }}
        </h3>

        <mat-form-field
          class="sp-width__full sp-margin__bottom-x2"
          appearance="fill"
          color="accent">
          <mat-label>
            {{ 'GENERAL.CHANGE_REASON_LABEL' | translate }}
          </mat-label>
          <textarea
            matInput
            rows="4"
            formControlName="note"
            [errorStateMatcher]="error_matcher"
            required></textarea>
        </mat-form-field>
      </form>
    </div>

    <app-shared-button
      class="sp-width__full"
      [button_class]="'sp-button__main'"
      [spinner_class]="'sp-spinner__main'"
      [cta]="'GENERAL.CONFIRM_CTA'"
      [is_disabled]="
        !isResidencyFormValid() ||
        !isPersonalInfoFormValid() ||
        !isPersonalIdFormValid() ||
        !isDomicileFormValid() ||
        !isAmlFormValid() ||
        !isNoteFormValid() ||
        is_buyer_edit_running
      "
      [is_spinner_visible]="is_buyer_edit_running"
      (click)="onConfirmClick()"></app-shared-button>
  </div>
</div>
